import { Component } from "@stencil/core";

/**
 * The `ch-grid-rowset-empty` component represents a container to "empty message" when ch-grid-rowset is empty.
 * @deprecated Use `ch-tabular-grid` component instead. Use `ch-tabular-grid-rowset-empty` instead.
 */
@Component({
  tag: "ch-grid-rowset-empty",
  styleUrl: "ch-grid-rowset-empty.scss",
  shadow: false
})
export class ChGridRowsetEmpty {}
